/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__authorizeUrl_string__ } from '../models/ControllerResponse__authorizeUrl_string__';
import type { ControllerResponse__enabled_boolean__ } from '../models/ControllerResponse__enabled_boolean__';
import type { ControllerResponse__name_string_signInUrl_string_issuer_string_domains_string_Array_legacySSO_boolean__ } from '../models/ControllerResponse__name_string_signInUrl_string_issuer_string_domains_string_Array_legacySSO_boolean__';
import type { ControllerResponse_SsoDomainCheck_Array_ } from '../models/ControllerResponse_SsoDomainCheck_Array_';
import type { ControllerResponse_SsoDomainVerification_ } from '../models/ControllerResponse_SsoDomainVerification_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SsoService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a SAML SSO connection for the caller's organization.
     * Only organization owners and admins can create this.
     * @param formData
     * @returns any Created
     * @throws ApiError
     */
    public create(
        formData: {
            certificateFile: Blob;
            connectionName: string;
            issuer: string;
            signinUrl: string;
            domains: string;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization/sso',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Delete the SAML SSO connection for the caller's organization, including the
     * Auth0 connection. Only organization owners and admins can delete this.
     * @returns void
     * @throws ApiError
     */
    public delete(): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/organization/sso',
        });
    }
    /**
     * Get the SAML SSO connection configuration for the caller's organization.
     * Only organization owners and admins can view this.
     * @returns ControllerResponse__name_string_signInUrl_string_issuer_string_domains_string_Array_legacySSO_boolean__ Ok
     * @throws ApiError
     */
    public show(): CancelablePromise<ControllerResponse__name_string_signInUrl_string_issuer_string_domains_string_Array_legacySSO_boolean__> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organization/sso',
        });
    }
    /**
     * Return the organization's DNS TXT value. The same value is published on
     * each email domain. Create checks those records before the Auth0 connection is made.
     * @returns ControllerResponse_SsoDomainVerification_ Ok
     * @throws ApiError
     */
    public previewDomainVerification(): CancelablePromise<ControllerResponse_SsoDomainVerification_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organization/sso/domain-verification-code',
        });
    }
    /**
     * Look up the TXT record for each submitted domain. A missing record is still
     * a successful response so setup can show which domains are not found yet.
     * Create checks the same records again before the Auth0 connection is made.
     * @param requestBody
     * @returns ControllerResponse_SsoDomainCheck_Array_ Ok
     * @throws ApiError
     */
    public verifyDomains(
        requestBody: {
            domains: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_SsoDomainCheck_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/organization/sso/verify-domains',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Whether production SSO is on for the caller's organization. Auth0 is the
     * source of truth: both the SPA and the M2M app must be enabled. The Verify
     * SSO client is ignored.
     * @returns ControllerResponse__enabled_boolean__ Ok
     * @throws ApiError
     */
    public getConnectionStatus(): CancelablePromise<ControllerResponse__enabled_boolean__> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organization/sso/status',
        });
    }
    /**
     * Turn production SSO on or off for the caller's organization. Only the SPA
     * and M2M clients change. The Verify SSO client stays enabled.
     * @param requestBody
     * @returns ControllerResponse__enabled_boolean__ Ok
     * @throws ApiError
     */
    public setConnectionStatus(
        requestBody: {
            enabled: boolean;
        },
    ): CancelablePromise<ControllerResponse__enabled_boolean__> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organization/sso/status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get an Auth0 authorize URL for verifying this organization's SAML connection
     * with the Verify SSO application. This URL will be a redirect URL the user can
     * use to sign in via SSO. When successful, it will call our `verify/callback`
     * route below to verify the attributes.
     * @returns ControllerResponse__authorizeUrl_string__ Ok
     * @throws ApiError
     */
    public getVerifySsoAuthorizeUrl(): CancelablePromise<ControllerResponse__authorizeUrl_string__> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organization/sso/verify',
        });
    }
    /**
     * Auth0 redirect target for Verify SSO logins. Exchanges the code, inspects the
     * id_token, and checks that the login maps to the admin who started verification.
     * The browser gets a short HTML result page. Failure details stay in the logs.
     * @param code
     * @param state
     * @param error
     * @param errorDescription
     * @returns void
     * @throws ApiError
     */
    public verifyCallback(
        code?: string,
        state?: string,
        error?: string,
        errorDescription?: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organization/sso/verify/callback',
            query: {
                'code': code,
                'state': state,
                'error': error,
                'error_description': errorDescription,
            },
        });
    }
}
